import { render, staticRenderFns } from "./UserCollaborationWorkspaces.vue?vue&type=template&id=209ba1fd&"
import script from "./UserCollaborationWorkspaces.vue?vue&type=script&lang=js&"
export * from "./UserCollaborationWorkspaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports